import React from 'react';
import {IdMirrorCard} from './id-mirror-card';
import {DarkC2Image, LightC2Image} from '../../../data/id-mirror-data';

const titleDark = 'Una leyenda que se electrifica';
const descriptionDark = (
  <>
    <b>Por primera vez, tu Polo es 100% eléctrico.</b>
    {/* Diseñado para que disfrutes las ventajas de una conducción sin emisiones y una autonomía hasta 450 km para acompañarte en todos tus planes. */}
  </>
);

const titleLight = 'Un icono con más de 50 años';
const descriptionLight = (
  <>
    <b>
      Esta leyenda tiene más de 5 décadas de historia y ha sido el primer coche
      de muchas generaciones.
    </b>{' '}
    {/* Un compañero práctico y perfecto para ir contigo a cada uno de tus planes. */}
  </>
);

export const Card2 = ({
  isMobileCard = false,
  cardInfoDarkRef,
  cardInfoLightRef,
}: {
  isMobileCard?: boolean;
  cardInfoLightRef?: React.Ref<HTMLDivElement>;
  cardInfoDarkRef?: React.Ref<HTMLDivElement>;
}) => {
  return (
    <IdMirrorCard
      titleLight={titleLight}
      descriptionLight={descriptionLight}
      imageLight={LightC2Image}
      titleDark={titleDark}
      descriptionDark={descriptionDark}
      imageDark={DarkC2Image}
      cardNumber={'2'}
      isMobileCard={isMobileCard}
      cardInfoDarkRef={cardInfoDarkRef}
      cardInfoLightRef={cardInfoLightRef}
    />
  );
};
